import React from "react";

const TeamActionButtons = ({
    team,
    onDelete,
    onInvite,
    onLeave,
    showDelete,
    showInvite,
    showLeave,
    inviteDisabled
}) => (
    <div className="flex gap-x-2">
        {showDelete && (
            <button
                className="flex items-center gap-1 px-3 py-1.5 text-xs font-semibold rounded-full bg-gradient-to-r from-red-500 to-red-700 text-white shadow hover:from-red-600 hover:to-red-900 transition-all"
                onClick={onDelete}
                title="Delete Team"
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                Delete
            </button>
        )}
        {showInvite && (
            <button
                className="flex items-center gap-1 px-3 py-1.5 text-xs font-semibold rounded-full bg-gradient-to-r from-sky-400 to-sky-600 text-white shadow hover:from-sky-500 hover:to-sky-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={onInvite}
                title="Invite Members"
                disabled={inviteDisabled}
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M8.5 7A4.5 4.5 0 1117 7a4.5 4.5 0 01-9 0zM20 8v6M23 11h-6" /></svg>
                Invite members
            </button>
        )}
        {showLeave && (
            <button
                className="flex items-center gap-1 px-3 py-1.5 text-xs font-semibold rounded-full bg-gradient-to-r from-gray-400 to-gray-600 text-white shadow hover:from-gray-500 hover:to-gray-700 transition-all"
                onClick={onLeave}
                title="Leave Team"
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7" /></svg>
                Leave team
            </button>
        )}
    </div>
);

export default TeamActionButtons;
